import { Snackbar } from "@mui/material";
import styled from "styled-components";

interface StyledSnackbarProps {
    $variant: "success" | "error";
}

export const StyledSnackbar = styled(Snackbar)<StyledSnackbarProps>`
    && {
        .MuiSnackbarContent-root {
            background-color: ${({ theme, $variant }) => ($variant === "success" ? theme.palette.primary.main : theme.palette.secondary.main)};
        }
    }
`;
